import { render, staticRenderFns } from "./NuevoCaso.vue?vue&type=template&id=1c372fa0&scoped=true&"
import script from "./NuevoCaso.vue?vue&type=script&lang=js&"
export * from "./NuevoCaso.vue?vue&type=script&lang=js&"
import style0 from "./NuevoCaso.vue?vue&type=style&index=0&id=1c372fa0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c372fa0",
  null
  
)

export default component.exports